<template>
  <div class="news_editor">
    <modal class="news-added-modal" width="45%" height="auto" name="news-added-modal">
      <div class="modal_content">
        <h2>La news a bien été ajoutée</h2>
      </div>
    </modal>
    <div class="title">
      <label>
        <strong>Titre :</strong>
      </label>
      <input type="text" v-model="news_title" />
    </div>

    <div class="editor">
      <label>
        <strong>Contenu de la news :</strong>
      </label>
      <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
        <div class="menubar">
          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.bold() }"
            @click="commands.bold"
          >
            <strong>G</strong>
          </button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.italic() }"
            @click="commands.italic"
          >
            <span style="font-style: italic">I</span>
          </button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.underline() }"
            @click="commands.underline"
          >
            <span style="text-decoration: underline">S</span>
          </button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.heading({ level: 2 }) }"
            @click="commands.heading({ level: 2 })"
          >Titre</button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.bullet_list() }"
            @click="commands.bullet_list"
          >Liste</button>
        </div>
      </editor-menu-bar>

      <editor-content class="editor-content" :editor="editor" />
    </div>

    <div class="add-news-button">
      <button @click="addNews()">AJOUTER LA NEWS</button>
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Heading,
  BulletList,
  ListItem,
  Bold,
  Italic,
  Underline,
  Placeholder,
} from 'tiptap-extensions';

import { newsCollection } from '../../firebase';

export default {
  name: 'NewsEditor',
  components: { EditorContent, EditorMenuBar },
  data() {
    return {
      news_title: '',
      news_content: '',
      editor: new Editor({
        extensions: [
          new BulletList(),
          new Heading({ levels: [2] }),
          new ListItem(),
          new Bold(),
          new Italic(),
          new Underline(),
          new Placeholder({
            emptyNodeText: 'Ecrire le contenu ici',
          }),
        ],
        content: '',
        onUpdate: ({ getHTML }) => {
          this.news_content = getHTML();
        },
      }),
    };
  },
  methods: {
    addNews() {
      const news = {
        title: this.news_title,
        content: this.news_content,
        createdAt: new Date().toLocaleDateString('fr-FR'),
      };

      newsCollection.add(news);
      this.news_title = this.news_content = '';
      this.editor.setContent('');

      this.$modal.show('news-added-modal');

      setTimeout(() => {
        this.$modal.hide('news-added-modal');
      }, 2000);
    },
  },
  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>

<style lang="scss">
.editor p.is-empty:first-child::before {
  content: attr(data-empty-text);
  float: left;
  color: #aaa;
  pointer-events: none;
  height: 0;
  font-style: italic;
}

.news-added-modal {
  .modal_content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h2 {
    font-size: 32px;

    margin-left: auto;
    margin-right: auto;
    padding: 16px;
    text-align: center;
  }
}

.news_editor {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .title {
    padding: 16px 0px;
    margin-bottom: 8px;

    input {
      margin-left: 16px;
      width: 320px;
    }
  }
  .editor {
    width: 880px;
  }

  .editor-content {
    padding: 4px;
    border: 2px solid black;

    border-radius: 2px;
    background-color: white;
    border: 1px solid lightgray;
  }

  .add-news-button {
    margin-top: 16px;
    font-size: 16px;
    display: flex;

    button {
      background-color: lightblue;
      height: 32px;
      width: 256px;
      color: black;
      font-weight: bold;
      border: 1px solid black;
      cursor: pointer;

      &:hover {
        border: 3px solid black;
      }
    }
  }
}
</style>
